import { SwipeableDrawer, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Util from "../../../Util";
import Close from "../../../assets/Icon/close.png";
import { useTranslation } from "react-i18next";
import Invalid from "../../../assets/Icon/invalid.svg";
import Calander from "../../../assets/Icon/calendar.svg";
import DatePicker from "react-datepicker";
import clock from "../../../assets/Icon/clock.svg";
import ApiCalling from "../../../network/ApiCalling";
import ToastHOC from "../../HOC/ToastHOC";
import ExitAlert from "../../../components/ExitAlert";
import * as moment from "moment";

const AddNewEnquiry = (props) => {
  const show = props.show;
  const onClose = props.onClose;
  const onSave = props.onSave;
  const enquiryData = props.enquiryData;
  const isEdit = props.isEdit;
  const openModal = props.openModal;
  const enquiryInfo = props.enquiryInfo;
  const { t } = useTranslation();
  const getLanguage = Util.getSelectedLanguage();
  const [parentFN, setParentFN] = useState("");
  const [parentFNError, setParentFNError] = useState("");
  const [parentLN, setParentLN] = useState("");
  const [parentLNError, setParentLNError] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [email, setEmail] = useState("");
  const [isStateUpdated, setIsStateUpdated] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [dob, setDob] = useState(null);
  const [dobError, setDobError] = useState("");
  const [gender, setGender] = useState(0);
  const school = Util.getSelectedSchool();
  const [statusId, setStatusId] = useState(0);
  const [statusIdError, setStatusIdError] = useState("");
  const [leadSourceId, setLeadSourceId] = useState(0);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [appointmentTime, setAppointmentTime] = useState(null);
  const [assignedTo, setAssignedTo] = useState(0);
  const [followUpDate, setFollowUpDate] = useState(null);
  const [notes, setNotes] = useState("");
  const [enquiryStatusList, setEnquiryStatusList] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [alertModal, setIsAlertModal] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [enrolledDate, setEnrolledDate] = useState(null);
  const [appointmentTimeError, setAppointmentTimeError] = useState("");
  const [assignedToError, setAssignedToError] = useState("");
  const [gradeId, setGradeId] = useState(0);
  const [gradeList, setGradeList] = useState([]);
  const [roomId, setRoomId] = useState(0);
  const [roomList, setRoomList] = useState([]);
  const [gradeError, setGradeError] = useState("");
  const [roomError, setRoomError] = useState("");

  const handleChangeParentFN = (e) => {
    setParentFN(e.target.value);
    setParentFNError("");
    setIsStateUpdated(true);
  };

  const handleChangeParentLN = (e) => {
    setParentLN(e.target.value);
    setParentLNError("");
    setIsStateUpdated(true);
  };

  const handleChangePhoneNo = (e) => {
    setPhoneNo(e.target.value);
    setPhoneNoError("");
    setIsStateUpdated(true);
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    setIsStateUpdated(true);
  };

  const handleChangeFirstName = (e) => {
    setFirstName(e.target.value);
    setFirstNameError("");
    setIsStateUpdated(true);
  };

  const handleChangeLastName = (e) => {
    setLastName(e.target.value);
    setLastNameError("");
    setIsStateUpdated(true);
  };

  const handleChangeDob = (date) => {
    setDob(date);
    setDobError("");
    setIsStateUpdated(true);
  };

  const handleChangeGender = (e) => {
    setGender(e.target.value);
    setIsStateUpdated(true);
  };

  const handleChangeStatus = (e) => {
    const value = e;
    console.log(value);
    if (value) {
      setStatusId(e);
      setStatusIdError("");
      setIsStateUpdated(true);
    } else {
      console.error("Invalid value:", value);
    }
  };

  const handleChangeLeadSource = (e) => {
    setLeadSourceId(e.target.value);
    setIsStateUpdated(true);
  };

  const handleChangeAppDate = (date) => {
    setAppointmentDate(date);
    setIsStateUpdated(true);
  };

  const handleChangeAppTime = (time) => {
    setAppointmentTime(time);
    setAppointmentTimeError("");
    setIsStateUpdated(true);
  };

  const handleChangeAssignedTo = (e) => {
    setAssignedTo(e.target.value);
    setAssignedToError("");
    setIsStateUpdated(true);
  };

  const handleChangeFollowUp = (date) => {
    setFollowUpDate(date);
    setIsStateUpdated(true);
  };

  const handleChangeNotes = (e) => {
    setNotes(e.target.value);
    setIsStateUpdated(true);
  };

  const handleChangeGrade = (e) => {
    setGradeId(e.target.value);
    setIsStateUpdated(true);
    setGradeError("");
    setRoomId(0);
  };

  const handleChangeRoom = (e) => {
    setRoomId(e.target.value);
    setIsStateUpdated(true);
    setRoomError("");
  };

  const CustomInput = ({ value, onClick, icon }) => (
    <div className=" d-flex" onClick={onClick}>
      <input className="custom-input__field" value={value} readOnly />
      <div className="custom-input__icon">
        <img src={icon} alt="Calander" className="svg-icon calender-icon" />
      </div>
    </div>
  );

  const genderList = [
    { id: 1, value: "Female" },
    { id: 2, value: "Male" },
  ];

  const getEnquiryStatusList = () => {
    ApiCalling.apiCallParamsGet("enquiry_status/list")
      .then((res) => {
        setEnquiryStatusList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getTypeList = () => {
    ApiCalling.apiCallParamsGet("lead_sources/list")
      .then((res) => {
        setLeadSourceList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getStaffList = async () => {
    const data = {
      page_size: 1000,
      page_number: 1,
      role_id: 0,
      str_search: "",
    };
    ApiCalling.apiCallBodyDataPost("user/list", data)
      .then((res) => {
        setUserList(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getGradeList = async () => {
    ApiCalling.apiCallBodyDataGet("grade/list")
      .then((res) => {
        setGradeList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getRoomList = async (gradeIdParam) => {
    console.log(gradeIdParam);
    ApiCalling.apiCallBodyDataGet("classroom/list")
      .then((res) => {
        console.log(res);
        const modifiedClassList = res.data
          // .filter((g) => gradeId == 0 || g.Grade.id == gradeId)
          .filter(
            (g) =>
              Number(gradeIdParam) == 0 || g.Grade.id == Number(gradeIdParam)
          )
          .map((classroom) => ({
            id: classroom.id,
            name: `${classroom.name}`,
          }));
        setRoomList(modifiedClassList);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    console.log(isEdit, gradeId);
    if (!isEdit) {
      setRoomId(0);
      getRoomList(gradeId);
    } else {
      getRoomList(gradeId);
    }
  }, [gradeId]);

  useEffect(() => {
    getEnquiryStatusList();
    getTypeList();
    getStaffList();
    getGradeList();
    getRoomList();
  }, []);

  // useEffect(() => {
  //   console.log(isEdit);
  //   if (enquiryStatusList) {
  //     if (!isEdit && show) {
  //       const data = enquiryStatusList;
  //       const filterdata = data.find((item) => item.references === "LEAD");
  //       setStatusId(filterdata?.id);
  //       console.log(filterdata)
  //     }
  //   }
  // }, [isEdit, show]);

  const handleSave = () => {
    setIsStateUpdated(false);
    setFirstNameError("");
    setLastNameError("");
    setParentFNError("");
    setParentLNError("");
    setPhoneNoError("");
    setDobError("");
    setStatusIdError("");
    setGradeError("");
    setRoomError("");
    let error = false;
    if (firstName === "" || firstName === undefined) {
      setFirstNameError("Student First name is required");
      error = true;
    }
    if (lastName === "" || lastName === undefined) {
      setLastNameError("Student Last name is required");
      error = true;
    }
    if (parentFN === "" || parentFN === undefined) {
      setParentFNError("Parent First name is required");
      error = true;
    }
    if (parentLN === "" || parentLN === undefined) {
      setParentLNError("Parent Last name is required");
      error = true;
    }
    if (phoneNo === "" || phoneNo === undefined) {
      setPhoneNoError("Phone Number is required");
      error = true;
    }
    if (dob === null || dob === undefined) {
      setDobError("Date of birth is required");
      error = true;
    }
    if (gradeId === 0) {
      setGradeError("Grade is required");
      error = true;
    }
    if (roomId == 0) {
      setRoomError("Classroom is required");
      error = true;
    }
    // if (
    //   statusId === 0 ||
    //   statusId === "" ||
    //   statusId === undefined ||
    //   statusId === null
    // ) {
    //   setStatusIdError("Status is required");
    //   error = true;
    // }
    if (appointmentDate !== null) {
      if (appointmentTime === null) {
        setAppointmentTimeError("Appointment Time is required");
        error = true;
      }
      if (assignedTo === 0 || assignedTo === undefined) {
        setAssignedToError("Assigned To is required");
        error = true;
      }
    }
    // console.log(error);
    if (!error) {
      const data1 = enquiryStatusList;
      const filterdata1 = data1.find((item) => item.references === "LEAD");
      const updateid = filterdata1.id;
      const data = {
        student_first_name: firstName,
        student_last_name: lastName,
        dob: dob,
        gender: gender,
        parent_first_name: parentFN,
        parent_last_name: parentLN,
        phone_number: phoneNo,
        email: email,
        enquiry_status_id: isEdit ? statusId : updateid,
        lead_source_id: leadSourceId === 0 ? null : leadSourceId,
        appointment_date: appointmentDate,
        appointment_time: appointmentTime,
        assigned_to: assignedTo === 0 ? null : assignedTo,
        follow_up_date: moment(followUpDate).format("YYYY-MM-DD"),
        notes: notes,
        grade_id: gradeId,
        classroom_id: roomId,
      };
      console.log(data);
      const filterdata = enquiryStatusList.filter(
        (item) => item.id === Number(statusId)
      );
      if (filterdata[0]?.references === "ADMITTED") {
        if (isEdit) {
          data.id = enquiryData?.id;
          data.student_enquiry_id = enquiryData?.student_enquiry_id;
          data.stage_id = enquiryData?.Grade?.stage_id;
          openModal();
          enquiryInfo(data);
          return;
        } else {
          openModal();
          enquiryInfo(data);
          return;
        }
      }
      if (isEdit) {
        data.id = enquiryData?.id;
        data.student_enquiry_id = enquiryData?.student_enquiry_id;
        ApiCalling.apiCallBodyDataPost("student_enquiry/update", data)
          .then((res) => {
            if (res.data.status) {
              onSave(
                "Updated Enquiry Successfully",
                "You have successfully updated Enquiry"
              );
            }
          })
          .catch((err) => {
            console.log("err", err);
          })
          .finally(() => {
            reset();
          });
      } else {
        ApiCalling.apiCallBodyDataPost("student_enquiry/add", data)
          .then((res) => {
            if (res.data.status) {
              onSave(
                "Added Enquiry Successfully",
                "You have successfully added new Enquiry"
              );
            }
          })
          .catch((err) => {
            console.log("err", err);
          })
          .finally(() => {
            reset();
          });
      }
    }
  };

  const reset = () => {
    setParentFN("");
    setParentFNError("");
    setParentLN("");
    setParentLNError("");
    setPhoneNo("");
    setPhoneNoError("");
    setEmail("");
    setFirstName("");
    setFirstNameError("");
    setLastName("");
    setLastNameError("");
    setDob(null);
    setDobError("");
    setGender(0);
    setStatusId(0);
    setStatusIdError("");
    setLeadSourceId(0);
    setAppointmentDate(null);
    setAppointmentTime("");
    setAssignedTo(0);
    setFollowUpDate(null);
    setAppointmentTimeError("");
    setAssignedToError("");
    setNotes("");
    setGradeId(0);
    setGradeError("");
    setRoomId(0);
    setRoomError("");
  };

  useEffect(() => {
    if (
      enquiryData === null ||
      (Object.keys(enquiryData).length === 0 &&
        enquiryData.constructor === Object)
    ) {
      reset();
      setIsDisable(false);
    } else {
      console.log(enquiryData);
      setFirstName(enquiryData?.StudentEnquiry?.student_first_name);
      setLastName(enquiryData?.StudentEnquiry?.student_last_name);
      setPhoneNo(enquiryData?.StudentEnquiry?.phone_number);
      setEmail(enquiryData?.StudentEnquiry?.email);
      setParentFN(enquiryData?.StudentEnquiry?.parent_first_name);
      setParentLN(enquiryData?.StudentEnquiry?.parent_last_name);
      setDob(
        enquiryData?.StudentEnquiry?.dob == null
          ? null
          : new Date(enquiryData?.StudentEnquiry?.dob)
      );
      setGender(enquiryData?.StudentEnquiry?.gender);
      setStatusId(enquiryData?.EnquiryStatus?.id);
      setLeadSourceId(
        enquiryData?.LeadSources === null ? 0 : enquiryData?.LeadSources?.id
      );
      setAppointmentDate(
        enquiryData?.appointment_date == null
          ? null
          : new Date(enquiryData?.appointment_date)
      );
      setAppointmentTime(
        enquiryData?.appointment_time == null
          ? null
          : enquiryData?.appointment_time
      );
      setAssignedTo(
        enquiryData?.assigned_to === null ? 0 : enquiryData?.User?.id
      );
      setFollowUpDate(
        enquiryData?.follow_up_date == null
          ? null
          : new Date(enquiryData?.follow_up_date)
      );
      setNotes(enquiryData?.notes);
      if (enquiryData?.EnquiryStatus?.references === "ADMITTED") {
        setIsDisable(true);
        setEnrolledDate(new Date(enquiryData?.modified_on));
      } else {
        setIsDisable(false);
      }
      setGradeId(enquiryData?.grade_id);
      setRoomId(enquiryData?.classroom_id);
    }
  }, [enquiryData]);

  return (
    <div>
      <SwipeableDrawer
        anchor={getLanguage == "ar" ? "left" : "right"}
        open={show}
        onClose={() => {
          if (isStateUpdated) {
            setIsAlertModal(true);
          } else {
            // setObservationById(null);
            onClose();
            reset();
            setIsStateUpdated(false);
          }
        }}
        onOpen={() => {}}
      >
        <div
          className="box-area"
          style={{
            position: "relative",
            width: "100%",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Box sx={{ width: "656px", padding: "20px" }} role="presentation">
            <div className="d-flex align-items-center justify-content-between">
              <div className="drawer-header">
                {isEdit ? t("Edit Enquiry") : t("Create New Enquiry")}
              </div>
              <button className="hidden-btn">
                <img
                  src={Close}
                  alt="Close"
                  className="svg-icon"
                  onClick={() => {
                    if (isStateUpdated) {
                      setIsAlertModal(true);
                    } else {
                      onClose();
                      // setObservationById(null);
                      reset();
                      setIsStateUpdated(false);
                    }
                  }}
                  height={20}
                  width={20}
                />
              </button>
            </div>
            <hr style={{ backgroundColor: "#E5E7EB" }} />
            <div className="body mt-3">
              <div className="row mt-2">
                <div
                  className="d-flex justify-content-between align-items-center mb-1"
                  style={{ fontWeight: "bold", fontSize: "18px" }}
                >
                  <div>Parent Details</div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Parent First Name")}
                    </span>
                    <input
                      className={`form-control ${
                        parentFNError.length > 0
                          ? "input-error"
                          : "custom-input"
                      }`}
                      // placeholder="Parent Name"
                      type="text"
                      onChange={handleChangeParentFN}
                      value={parentFN}
                      disabled={isDisable}
                    />
                    {parentFNError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {parentFNError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Parent Last Name")}
                    </span>
                    <input
                      className={`form-control ${
                        parentLNError.length > 0
                          ? "input-error"
                          : "custom-input"
                      }`}
                      // placeholder="Parent Name"
                      type="text"
                      onChange={handleChangeParentLN}
                      value={parentLN}
                      disabled={isDisable}
                    />
                    {parentLNError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {parentLNError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Phone Number")}
                    </span>
                    <input
                      className={`form-control ${
                        phoneNoError.length > 0 ? "input-error" : "custom-input"
                      }`}
                      // placeholder="Phone Number"
                      type="number"
                      onChange={handleChangePhoneNo}
                      value={phoneNo}
                      disabled={isDisable}
                    />
                    {phoneNoError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {phoneNoError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Email")}</span>
                    <input
                      className="form-control custom-input"
                      // placeholder="Email"
                      type="text"
                      onChange={handleChangeEmail}
                      value={email}
                      disabled={isDisable}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div
                  className="d-flex justify-content-between align-items-center mb-1"
                  style={{ fontWeight: "bold", fontSize: "18px" }}
                >
                  <div>Student Details</div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Student First Name")}
                    </span>
                    <input
                      className={`form-control ${
                        firstNameError.length > 0
                          ? "input-error"
                          : "custom-input"
                      }`}
                      // placeholder="Student Name"
                      type="text"
                      onChange={handleChangeFirstName}
                      value={firstName}
                      disabled={isDisable}
                    />
                    {firstNameError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {firstNameError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Student Last Name")}
                    </span>
                    <input
                      className={`form-control ${
                        lastNameError.length > 0
                          ? "input-error"
                          : "custom-input"
                      }`}
                      // placeholder="Student Name"
                      type="text"
                      onChange={handleChangeLastName}
                      value={lastName}
                      disabled={isDisable}
                    />
                    {lastNameError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {lastNameError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("Date of birth")}
                    </span>
                    <DatePicker
                      placeholderText="Select date"
                      selected={dob}
                      onChange={handleChangeDob}
                      dateFormat={school.date_format}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      popperPlacement="bottom"
                      customInput={<CustomInput icon={Calander} />}
                      maxDate={new Date()}
                      disabled={isDisable}
                    />
                    {dobError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {dobError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Gender")}</span>
                    <select
                      name="type"
                      id="type"
                      className="select-dropdown form-select custom-input"
                      value={gender}
                      onChange={handleChangeGender}
                      disabled={isDisable}
                    >
                      <option value={0} disabled>
                        {t("Select type")}
                      </option>
                      {genderList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div
                  className="d-flex justify-content-between align-items-center mb-1"
                  style={{ fontWeight: "bold", fontSize: "18px" }}
                >
                  <div>Inquiry Info</div>
                </div>
                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">{t("Status")}</span>
                    <select
                      name="type"
                      id="type"
                      className={`form-select custom-input ${
                        statusIdError.length > 0 && "input-error"
                      }`}
                      onChange={(e) => handleChangeStatus(e.target.value)}
                      disabled={isDisable}
                      value={statusId}
                    >
                      {/* <option>
                        {t("Select type")}
                      </option> */}
                      {enquiryStatusList.map((item) => {
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                            disabled={
                              isEdit ? false : item.references !== "LEAD"
                            }
                          >
                            {item.status}
                          </option>
                        );
                      })}
                    </select>
                    {statusIdError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {statusIdError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Lead Source")}</span>
                    <select
                      name="type"
                      id="type"
                      className="select-dropdown form-select custom-input"
                      value={leadSourceId}
                      onChange={handleChangeLeadSource}
                      disabled={isDisable}
                    >
                      <option value={0} disabled>
                        {t("Select type")}
                      </option>
                      {leadSourceList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.type}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Appointment date")}</span>
                    <DatePicker
                      placeholderText="Select date"
                      selected={appointmentDate}
                      onChange={handleChangeAppDate}
                      dateFormat={school.date_format}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="datePicker"
                      popperPlacement="bottom"
                      customInput={<CustomInput icon={Calander} />}
                      disabled={isDisable}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Appointment Time")}</span>
                    <DatePicker
                      selected={
                        Util.isValidData(appointmentTime)
                          ? new Date(appointmentTime)
                          : null
                      }
                      onChange={handleChangeAppTime}
                      dateFormat={school.time_format}
                      popperPlacement="bottom"
                      className={`form-control cutom-input`}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      customInput={<CustomInput icon={clock} />}
                      placeholderText={`${t("Select time")}*`}
                      disabled={isDisable}
                    />
                    {appointmentTimeError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {appointmentTimeError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Assigned To")}</span>
                    <select
                      name="type"
                      id="type"
                      className="select-dropdown form-select custom-input"
                      value={assignedTo}
                      onChange={handleChangeAssignedTo}
                      disabled={isDisable}
                    >
                      <option value={0} disabled>
                        {t("Select Staff")}
                      </option>
                      {userList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.firstName + " " + item.lastName}
                          </option>
                        );
                      })}
                    </select>
                    {assignedToError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {assignedToError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text">{t("Follow Up Date")}</span>
                    <DatePicker
                      placeholderText="Select date"
                      selected={followUpDate}
                      onChange={handleChangeFollowUp}
                      dateFormat={school.date_format}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="datePicker"
                      popperPlacement="bottom"
                      customInput={<CustomInput icon={Calander} />}
                      disabled={isDisable}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">{t("Grade")}</span>
                    <select
                      name="grade"
                      id="grade"
                      className="select-dropdown form-select custom-input"
                      value={gradeId}
                      onChange={handleChangeGrade}
                      disabled={isDisable}
                    >
                      <option value={0} disabled>
                        {t("Select Grade")}
                      </option>
                      {gradeList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                    {gradeError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {gradeError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="input-filed">
                    <span className="basic-text required">
                      {t("ClassRoom")}
                    </span>
                    <select
                      name="room"
                      id="room"
                      className="select-dropdown form-select custom-input"
                      value={roomId}
                      onChange={handleChangeRoom}
                      disabled={isDisable}
                    >
                      <option value={0} disabled>
                        {t("Select Classroom")}
                      </option>
                      {roomList.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                    {roomError && (
                      <span className="invalid-error">
                        <img
                          className="fa fa-exclamation-circle mr-2 invalid-svg"
                          src={Invalid}
                        />
                        {roomError}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md">
                  <div className="input-filed">
                    <span className="basic-text">{t("Notes")}</span>
                    <textarea
                      className="text-area text-area auto-height"
                      placeholder="Write..."
                      rows="4"
                      cols={4}
                      value={notes}
                      onChange={handleChangeNotes}
                      disabled={isDisable}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="border-top row"
              style={{
                position: "fixed",
                width: "656px",
                bottom: "0px",
                right: getLanguage !== "ar" && "0px",
                background: "#ffffff",
                padding: "10px",
              }}
            >
              {isDisable ? (
                <div
                  className="d-flex align-items-center col-md"
                  style={{ fontWeight: "bold" }}
                >
                  Student enrolled on
                  {moment(enrolledDate).format(
                    Util.getMomentDateTimeFormat(school.date_format)
                  )}
                </div>
              ) : (
                <div className="col-md">
                  <button
                    className="secondary-md-btn btn ml-2"
                    onClick={() => {
                      onClose();
                      reset();
                    }}
                  >
                    {t("Cancel")}
                  </button>
                </div>
              )}
              <div className="col-md">
                <button
                  style={{ float: "right" }}
                  className="primary-xl-btn btn"
                  onClick={handleSave}
                  disabled={isDisable}
                >
                  {isDisable ? "Enrol Student" : t("Submit")}
                </button>
              </div>
            </div>
          </Box>
        </div>
      </SwipeableDrawer>
      <ExitAlert
        visible={alertModal}
        onClose={() => {
          setIsAlertModal(false);
          setIsStateUpdated(false);
        }}
        onOk={() => {
          onClose();
          setIsAlertModal(false);
          reset();
          setIsStateUpdated(false);
        }}
      />
    </div>
  );
};

export default ToastHOC(AddNewEnquiry);
